import React, { useContext, useEffect } from 'react'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import SeoGeneral from '../BusinessPage/SeoGeneral';

function TermsofServices() {
  const colordata = useContext(Colorcontext);
  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  const seoMetaData = {
    title: "Neoo Search Terms & Conditions – User Agreement & Policies",
    description: "Read Neoo Search Terms & Conditions to understand the rules and guidelines for using our business directory and digital business card platform.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "Neoo Search Terms & Conditions – User Agreement & Policies",
    url: process.env.REACT_APP_APPLICATION_URL + "/terms-of-services",
    keywords: "Neoo Search, terms and conditions, policies, business directory, digital business card, platform rules",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/terms-of-services"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <section className='aboutneoosearch_sec searchloginmain'>
        <div className='cust_container'>
          <div className='toparea'>
            <h4 className='headline'>Neoo Search Terms & Conditions </h4>
            <p className='text'>Welcome to <strong>Neoo Search</strong>. By using our platform, you agree to comply with and be bound by the following Terms & Conditions. Please read them carefully.</p>
          </div>

          <div className='textarea'>
            <h4 className='headline'>1. Definitions</h4>
            <ul>
              <li className='text ml-5'><strong>“Platform” </strong> refers to Neoo Search digital business card (NeooCard) and business directory services.</li>
              <li className='text ml-5'><strong>“User” </strong> refers to any individual or business creating or accessing a digital business card, listing, or related service.</li>
              <li className='text ml-5'><strong>“Premium Services” </strong> refers to paid services, including premium NeooCard (AED 100) and Basic business listings (AED 300).</li>
              <li className='text ml-5'><strong>“We/Us/Our” </strong> refers to Neoo Search and its operators.</li>
            </ul>

            <h4 className='headline'>2. Eligibility</h4>
            <ul>
              <li className='text ml-5'>You must be at least 18 years old to use this platform.</li>
              <li className='text ml-5'>The company must be registered in the country where it does business.</li>
              <li className='text ml-5'>Businesses must ensure that information provided is true, accurate, and not misleading.</li>
            </ul>

            <h4 className='headline'>3. Services Provided</h4>
            <ul>
              <li className='text ml-5'><strong>Free Services:</strong> NeooCard creation.</li>
              <li className='text ml-5'><strong>Paid Services:</strong></li>
              <ul className='ml-5'>
                <li className='text ml-5'>Premium NeooCard (AED 100)</li>
                <li className='text ml-5'>Basic plan: Business Listing in Neoo Search Directory (AED 300)</li>
                <li className='text ml-5'>Silver plan: Business Listing in Neoo Search Directory (AED 400)</li>
                <li className='text ml-5'>Gold plan: Business Listing in Neoo Search Directory (AED 500)</li>
              </ul>
              <li className='text ml-5'>We reserve the right to modify pricing or features at any time.</li>
            </ul>

            <h4 className='headline'>4. User Responsibilities</h4>
            <ul>
              <li className='text ml-5'>Users must provide accurate, updated, and lawful content.</li>
              <li className='text ml-5'>Users are responsible for maintaining the confidentiality of their login credentials.</li>
              <li className='text ml-5'>Misuse of the platform (spam, false information, illegal content) may result in suspension or termination of your account.</li>
            </ul>

            <h4 className='headline'>5. Payments & Refunds</h4>
            <ul>
              <li className='text ml-5'>All payments are non-refundable unless required by applicable law.</li>
              <li className='text ml-5'>Payment details must be accurate and authorized by the user.</li>
              <li className='text ml-5'>Services will be activated only after confirmation of payment.</li>
            </ul>

            <h4 className='headline'>6. Intellectual Property</h4>
            <ul>
              <li className='text ml-5'>Users retain ownership of the content they upload but grant Neoo Search a license to display it on the platform.</li>
              <li className='text ml-5'>Neoo Search trademarks, branding, and technology cannot be copied or used without prior written consent.</li>
            </ul>

            <h4 className='headline'>7. Limitation of Liability</h4>
            <ul>
              <li className='text ml-5'>Neoo Search does not guarantee business success, customer acquisition, or financial results.</li>
              <li className='text ml-5'>We are not liable for third-party misuse of information shared publicly through business cards or directory listings.</li>
            </ul>

            <h4 className='headline'>8. Suspension & Termination</h4>
            <ul>
              <li className='text ml-5'>Accounts may be suspended or terminated if found violating these Terms.</li>
              <li className='text ml-5'>Illegal use of the platform may be reported to authorities.</li>
            </ul>

            <h4 className='headline'>9. Governing Law</h4>
            <ul>
              <li className='text ml-5'>These Terms are governed by the laws of the <strong>United Arab Emirates (UAE)</strong>.</li>
              <li className='text ml-5'>Disputes shall be subject to the exclusive jurisdiction of UAE courts.</li>
            </ul>

            <h4 className='headline'>10. Changes to Terms</h4>
            <ul>
              <li className='text ml-5'>Neoo Search reserves the right to update these Terms at any time.</li>
              <li className='text ml-5'>Continued use of the platform after changes indicates acceptance of the revised Terms.</li>
            </ul>

          </div>

        </div>
      </section>
    </>
  )
}

export default TermsofServices